import { RADIUS } from '@ab-core/radius';
import styled from 'styled-components';
import Button from './index';

export const PrimaryButton = styled(Button)`
    border-radius: ${RADIUS.MINIMAL} 0px 0px ${RADIUS.MINIMAL};
`;

export const SecondaryButton = styled(Button)`
    border-radius: 0px ${RADIUS.MINIMAL} ${RADIUS.MINIMAL} 0px;
`;

export const ComboButtonWrapper = styled.div`
    display: flex;
    gap: 1px;
`;
